import {
  IFieldArray,
  IFieldConfigurationObject,
  ITemplateScope,
} from "AngularFormly";
import fieldHelpers from "../../../../../ui-formly/fieldHelpers";
import { default as selectAsyncUtils } from "../../../../../ui-formly/types/selectAsync/utils";
import { EpromConfigurationsController } from "./epromConfigurationsController";

import { default as MachineServer } from "../../../Server";
import { isFunction } from "lodash";

const epromConfigurationsTemplate =
  require("!html-loader!./epromConfigurationsTemplate.html").default;

export function formlyEpromConfigurations(): IFieldConfigurationObject {
  return {
    controller: EpromConfigurationsController,
    template: epromConfigurationsTemplate,
    key: "EpromConfigurations",
    name: "EpromConfigurations",
    templateOptions: {
      osEpromField: getOsEpromField(MachineServer),
      fields: getRepeatingFields(MachineServer),
    },
  };
}

function getOsEpromField(server: any): IFieldArray {
  return getField(true, false, false, server);
}

function getRepeatingFields(server: any): IFieldArray {
  return getField(false, true, true, server);
}

function getField(
  includeSetChipVersion: boolean,
  includeDelete: boolean,
  includeTheme: boolean,
  server: any
): IFieldArray {
  const fields = [
    fieldHelpers.simpleStringField({
      key: "Eprom",
      name: "Eprom",
      label: "Packages",
    }),
    fieldHelpers.simpleReadonlyField({
      key: "EpromType",
      name: "EpromType",
      label: "Type",
    }),
  ];

  if (includeSetChipVersion) {
    fields.push(
      fieldHelpers.simpleStringField({
        key: "SetChipVersion",
        name: "SetChipVersion",
        label: "Set Chip Version",
        required: true,
      })
    );
  }

  if (includeTheme) {
    fields.push({
      key: "ThemeId",
      name: "ThemeId",
      type: "selectAsync",
      templateOptions: {
        required: true,
        label: "Theme",
        query: selectAsyncUtils.getQuery(server, "themeQuery"),
        saveNewItem: selectAsyncUtils.getSave(server, "themeSave"),
        showAddButton: false,
        getDefaultItem: function (model: any) {
          return {
            Id: model.ThemeId,
            Name: model.ThemeName,
          };
        },
        updateNameProp: "ThemeName",
      },
    });
  }

  if (includeDelete) {
    fields.push({
      key: "delete",
      template: `<div>
      <div class="pull-right">
        <div class="btn-group">
          <div class="btn btn-danger game-config-btn" ng-click="deleteRow(model)">
            <i class="glyphicon glyphicon-remove"></i>
          </div>
        </div>
      </div>
    </div>`,
      controller: deleteFieldController,
      wrapper: ["bootstrapLabel"],
      templateOptions: {
        label: "ㅤ",
      },
    });
  }

  return fieldHelpers.columnLayout(fields, 4);
}

interface deleteFieldControllerScope extends ITemplateScope {
  deleteRow(row: unknown): void;
}
class deleteFieldController {
  static $inject = ["$scope"];

  constructor(private readonly $scope: deleteFieldControllerScope) {
    this.$scope.deleteRow = this.deleteRow.bind(this);
  }

  deleteRow(model: unknown) {
    const repeaterController = this.findRepeaterControllerScope(this.$scope);
    repeaterController?.remove(model);
  }

  private findRepeaterControllerScope($scope: any): any {
    if (isFunction($scope.remove)) {
      return $scope;
    }

    return this.findRepeaterControllerScope($scope.$parent);
  }
}
